<mat-progress-bar *ngIf="loading" mode="indeterminate" color="warn"></mat-progress-bar>
<br>
<div *ngIf="!loading" style="overflow-y: auto; height: calc(70vh - 11em); border: 1px solid #ccc">
  <div [perfectScrollbar]="configPS">
<mat-accordion class="example-headers-align">
  <mat-expansion-panel *ngFor="let customer of customerList; let i = index">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex-container">
        <!--img style="width: 40px;" src="assets/images/svg/nerd.webp" alt="Beschreibung des SVG" class="mr-1"-->
        <strong class="flex-item">{{customer.company}}</strong>
        <span class="flex-item pull-right"><strong  [ngClass]="{'badge badge-success': countSelectedBranches(customer.customer_branch) > 0}">{{countSelectedBranches(customer.customer_branch)}}/{{customer.customer_branch.length}}</strong></span>
      </mat-panel-title>
      <mat-panel-description>           
      </mat-panel-description>
    </mat-expansion-panel-header>
    <table class="table table-striped">
      <tbody style="height: 20px">
        <tr *ngFor="let branch of customer.customer_branch; let i = index" class="cursor-pointer"  [ngClass]="{'green-background': branch.selected}">
          <td>
            <mat-checkbox [(ngModel)]="branch.selected" (change)="updateTeamLocations(branch)">
            </mat-checkbox>
          </td>
          <td><strong>{{branch.title}}</strong></td>
          <td></td>
          <td class="text-right"><!--img style="width: 40px;" src="assets/images/svg/nerd.webp" alt="Beschreibung des SVG"--></td>
      </tr>
      
      </tbody>
    </table>
  </mat-expansion-panel>
</mat-accordion>   
</div>
</div>
<button *ngIf="!loading" class="btn btn-outline-success" (click)="store()">speichern</button>
